import React from 'react';
import { AlertTriangle, AlertCircle, ShieldCheck } from 'lucide-react';

export const SequenceWarnings = ({ sequenceIssues }) => {
  if (sequenceIssues.length === 0) return null;

  return (
    <div className="bg-amber-500/10 rounded-2xl border border-amber-500/30 p-4" data-testid="sequence-warnings">
      <h3 className="text-amber-400 font-semibold mb-2 flex items-center gap-2">
        <AlertTriangle className="w-5 h-5" />
        Sequence Issues ({sequenceIssues.length})
      </h3>
      <p className="text-slate-400 text-xs mb-3">
        Diary entries must alternate WORK → REST → WORK → REST. The following issues were found:
      </p>
      <div className="space-y-2">
        {sequenceIssues.map((issue) => (
          <div key={issue.segment_ids?.join('-') || issue.message} className="flex items-start gap-2 p-2 bg-slate-800/60 rounded-lg">
            <AlertCircle className="w-4 h-4 text-amber-400 mt-0.5 flex-shrink-0" />
            <p className="text-slate-300 text-sm">{issue.message}</p>
          </div>
        ))}
      </div>
      <p className="text-amber-400/70 text-xs mt-3">
        Use &ldquo;Insert Missed Entry&rdquo; to add the missing REST or WORK segment to fix the sequence.
      </p>
    </div>
  );
};

export const SequenceOkBadge = () => (
  <div className="flex items-center gap-2 px-4 py-2 bg-emerald-500/10 border border-emerald-500/20 rounded-xl" data-testid="sequence-ok">
    <ShieldCheck className="w-4 h-4 text-emerald-400" />
    <span className="text-emerald-400 text-sm">Sequence valid — WORK/REST alternation is correct</span>
  </div>
);
